module.exports = __webpack_public_path__ + "static/media/directMessage.ca9a275c.svg";